import {Ellipsis} from "@FRAMEWORK/ui/desktop/text";
import styled from "styled-components";
import SpriteImage from "@PUBLIC/P/images/ico/ico_spr.png";

interface ButtonProps {
	direction?: "prev" | "next";
}

const Wrap = styled.div`
	position: relative;
	margin: 60px 0;
`;

const Rating = styled.span`
	margin-right: 10px;
	font-family: "pr-font-bold";
	&::before {
		display: inline-block;
		width: 20px;
		height: 20px;
		margin-right: 6px;
		background: url(${SpriteImage}) no-repeat -284px 0px;
		content: "";
	}
`;

const SlideWrap = styled.div`
	margin-top: 20px;
`;

const SlideContent = styled.div`
	padding: 25px 20px;
	height: 180px;
	border: 1px solid var(--line-color);
	border-radius: 12px;
	box-sizing: border-box;
	cursor: pointer;
`;
const ScoreWrap = styled.div`
	line-height: 1;
`;

const Score = styled.em`
	margin-left: 9px;
	font-family: "pr-font-bold";
	font-size: 16px;
	color: var(--emp-color);
`;

const Content = styled.p`
height: 72px;
	margin-top: 12px;
	${Ellipsis(3)};
`;

const MetaInfo = styled.div`
	display: flex;
	justify-content: end;
	gap: 10px;
	margin-top: 14px;
`;

const UserName = styled.span`
	color: var(--emp-color);
`;

const Date = styled.span`
	font-size: var(--basic-size);
`;

const SlideButtonWrap = styled.div`
	position: absolute;
	top: 0;
	right: 0;
	width: 60px;
	height: 30px;
	border: 1px solid var(--line-color);
	border-radius: 15px;
	box-sizing: border-box;

	button {
		position: relative;
		top: 0;
		left: 10px;
		width: 20px;
		height: 100%;
		background-color: transparent;

		&:after {
			position: absolute;
			top: 9px;
			display: block;
			width: 7px;
			height: 7px;
			border-top: 1px solid #222;
			border-right: 1px solid #222;
			font-size: 0;
			content: "";
		}
		&:disabled {
			&:after {
				border-color: var(--bl-color);
			}
		}
	}
`;
const SlideButton = styled.button<ButtonProps>`
	${props =>
		props.direction === "next" &&
		`&:after {
        right: 7px;
        transform: rotate(45deg);
    }`}
	${props =>
		props.direction === "prev" &&
		`&:after {
		left: 5px;
		transform: rotate(-135deg);
	}`}
`;

const SubTitleWrap = styled.div`
	display: flex;
	align-items: center;
	cursor: pointer;
`;

const ArrowIcon = styled.span`
	display: inline-block;
	width: 7px;
	height: 7px;
	margin-top: 0;
	margin-left: 14px;
	border-top: 1px solid var(--emp-color);
	border-left: 1px solid var(--emp-color);
	transform: rotate(135deg);
`;
export {
	Wrap,
	Rating,
	SlideWrap,
	SlideContent,
	ScoreWrap,
	Score,
	Content,
	MetaInfo,
	UserName,
	Date,
	SlideButtonWrap,
	SlideButton,
	ArrowIcon,
	SubTitleWrap,
};
